"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.headersForStream = exports.isBsonStream = exports.isHeaderStream = exports.isRawStream = exports.isStreamedPayload = exports.BsonStream = exports.HeaderStream = exports.RawStream = exports.StreamType = exports.ensureIterable = void 0;
const micro_streaming = __importStar(require("@journeyapps-platform/micro-streaming"));
const defs = __importStar(require("./definitions"));
/**
 * This is for web compatibility. Web based ReadableStreams are not iterable even though we type them as such
 */
const ensureIterable = (iterable) => {
    if (iterable instanceof micro_streaming.compat.Readable && !(Symbol.asyncIterator in iterable)) {
        return micro_streaming.iterableFromReadable(iterable);
    }
    return iterable;
};
exports.ensureIterable = ensureIterable;
var StreamType;
(function (StreamType) {
    StreamType["Raw"] = "raw";
    StreamType["Header"] = "header";
    StreamType["Bson"] = "bson";
})(StreamType || (exports.StreamType = StreamType = {}));
class RawStream {
    constructor(stream) {
        this.type = StreamType.Raw;
        this.header = undefined;
        this.encode = () => {
            return this.stream;
        };
        this.setHeader = () => {
            return new RawStream(this.stream);
        };
        this.stream = stream;
    }
}
exports.RawStream = RawStream;
class HeaderStream {
    constructor(stream, header) {
        this.type = StreamType.Header;
        this.encode = () => {
            return micro_streaming.bson.prependHeaderToStream(this.header, (0, exports.ensureIterable)(this.stream));
        };
        this.setHeader = (header) => {
            return new HeaderStream(this.stream, header);
        };
        this.stream = stream;
        this.header = header;
    }
}
exports.HeaderStream = HeaderStream;
class BsonStream {
    constructor(stream, header) {
        this.type = StreamType.Bson;
        this.setHeader = (header) => {
            return new BsonStream(this.stream, header);
        };
        this.stream = stream;
        this.header = header;
    }
    encode() {
        const encoded = micro_streaming
            .readableFrom(this.stream)
            .pipeThrough(micro_streaming.bson.createBSONStreamEncoder());
        return micro_streaming.bson.prependHeaderToStream(this.header, (0, exports.ensureIterable)(encoded));
    }
}
exports.BsonStream = BsonStream;
const isStreamedPayload = (payload) => {
    return Object.values(StreamType).includes(payload?.type);
};
exports.isStreamedPayload = isStreamedPayload;
const isRawStream = (payload) => {
    return payload?.type === 'raw';
};
exports.isRawStream = isRawStream;
const isHeaderStream = (payload) => {
    return payload?.type === 'header';
};
exports.isHeaderStream = isHeaderStream;
const isBsonStream = (payload) => {
    return payload?.type === 'bson';
};
exports.isBsonStream = isBsonStream;
const headersForStream = (stream) => {
    switch (stream.type) {
        case StreamType.Header: {
            return {
                [defs.Header.ContentType]: defs.ContentType.HeaderStream
            };
        }
        case StreamType.Bson: {
            return {
                [defs.Header.ContentType]: defs.ContentType.BSONStream
            };
        }
        default: {
            return {};
        }
    }
};
exports.headersForStream = headersForStream;
